import { ServiceStatus } from '../../../constants/service.constants';
import { Service } from '../../product/configuration-model';
import { EnrollmentContextService } from '../enrollment-context';

export const servicesMapper = (
	serviceConfig: Service[],
	enrollmentContext: EnrollmentContextService
): { name: string; state?: string; data?: string /* AWSJSON */ }[] => {
	// TODO Confirm that services sent as enrolled are processed as well
	// TODO Enhance the backend to remove the need of requesting FTO as confirmed
	const services = enrollmentContext
		.eligibleServices(serviceConfig)
		.map((service) => {
			return {
				name: service.name,
				state: service.static ? ServiceStatus.confirmed : undefined,
			};
		});

	return services;
};
